import $axios from "../api/accessor";
import { $api } from "../api/api";

export const HomeService = {
  async GetSlider() {
    let response = await $axios
      .get($api("get_slider"))
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },}